/**
 * Defines the constant literal values for boolean representations.
 *
 * These values can be used to convert string representations of booleans (for example, 'true', 'false', '1', '0')
 * into actual boolean types.
 */

export const BOOLEAN_LITERAL_VALUES = ['t', '1', 'true', 'f', '0', 'false'] as const;
